import React from "react";

import TabHeader from "../../../common/TabHeader";

const TabsHeader = ({ activeTab, setActiveTab, tabs }) => {
  return (
    <div className="project-dashboard-tabs flex mb-30">
      {tabs.map((tab, index) => (
        <TabHeader
          index={index}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          label={tab.name}
          itemCount={`${tab.count}/50`}
          key={tab.name}
        />
      ))}
    </div>
  );
};

export default TabsHeader;
